import { buildDemo } from './playerLogic';

// O ponto de entrada da demonstração de um exercício.
//
// Hoje a demonstração vem do que a biblioteca (e o exercício) já têm: fotografias e, quando existirem, animações ou vídeos carregados
// pelo ginásio. A futura biblioteca de demonstrações Gymag (vídeos/animações próprios) entra aqui, SEM mexer no overlay nem no player:
//
//   registerDemoProvider((exercise, library) => ({ media: [{ kind: 'video', url: '/demos/v1/leg-press.mp4', poster: '/demos/v1/leg-press.webp' }] }));
//
// Um fornecedor devolve (ou não) um pedaço da demonstração; o que devolver junta-se ao resto — a media dele vem primeiro — e os URLs passam
// sempre pelo mesmo filtro de segurança (só caminhos do servidor ou https). Se um fornecedor falhar, o player segue sem ele.

const providers = [];

export const registerDemoProvider = (provider) => {
  if (typeof provider !== 'function') return () => {};
  providers.push(provider);
  return () => {
    const index = providers.indexOf(provider);
    if (index >= 0) providers.splice(index, 1);
  };
};

export const clearDemoProviders = () => { providers.length = 0; };

export const resolveDemo = (exercise, library = exercise?.library) => {
  const base = buildDemo(exercise, library);
  const extras = [];

  for (const provider of providers) {
    try {
      const part = provider(exercise, library);
      if (part && typeof part === 'object') extras.push(part);
    } catch {
      // Um fornecedor que falha não pode tirar a demonstração (nem o treino) ao sócio.
    }
  }
  if (extras.length === 0) return base;

  // O que os fornecedores trazem passa pelo mesmo filtro que a biblioteca (e vem primeiro).
  const provided = buildDemo({ name: base.title }, { media: extras.flatMap((e) => e.media || []).map((m) => ({ url: m.url, kind: m.kind, altText: m.alt, source: m.source || 'gymag-demo' })) });
  const seen = new Set();
  const media = [...provided.media, ...base.media].filter((m) => (seen.has(m.url) ? false : seen.add(m.url)));
  return {
    ...base,
    media,
    steps: base.steps.length ? base.steps : extras.flatMap((e) => e.steps || []),
    mistakes: base.mistakes.length ? base.mistakes : extras.flatMap((e) => e.mistakes || []),
  };
};
